<template>
    <div class="container-super-invoices" v-if="superStore.isUltra || superStore.isMega">
        <InvoicesStatsCard :invoices="allInvoices" @filter-failed="filterFailed" @date-filter-changed="onDateFilterChanged" @filters-changed="onFiltersChanged" />
        <div class="row centered">
            <InvoicesTable ref="invoicesTable" is-super/>
        </div>
    </div>
    <div class="row centered" v-else>
        <AppLoader />
    </div>
</template>

<script>
import InvoicesTable from "@/user/components/super/InvoicesTable.vue";
import InvoicesStatsCard from "@/user/components/super/InvoicesStatsCard.vue";
import {useSuperStore} from "@/user/stores";
import {getLocalDateFromServer} from "@/shared/helpers/dates";
import API from "@/shared/helpers/API";
import AppLoader from "@/shared/components/AppLoader.vue";

export default {
    setup() {
        const superStore = useSuperStore();
        return {superStore};
    },
    components: {AppLoader, InvoicesTable, InvoicesStatsCard},
    name: "SuperInvoices",
    data() {
        // Initialize with last month date range (same as InvoicesStatsCard default)
        let end = new Date();
        let start = new Date();
        start.setMonth(start.getMonth() - 1);
        
        return {
            allInvoices: [],
            dateFilter: {
                start: start,
                end: end
            },
            typeFilter: null
        };
    },
    methods: {
        fetchInvoicesForDateRange(startDate, endDate) {
            const formatDateTime = (date, isEnd = false) => {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const time = isEnd ? '23:59:59' : '00:00:00';
                return `${year}-${month}-${day} ${time}`;
            };
            // Build filter object matching AppFilterGroup date filter pattern
            const filters = {
                page_size: 10000, // Still high but only for the filtered range
                date: '>' + formatDateTime(startDate, false),
                'businesses_invoices.date': '<' + formatDateTime(endDate, true)
            };
            
            // Add type filter if selected
            if (this.typeFilter && this.typeFilter.length > 0) {
                filters.type = this.typeFilter;
            }
            
            API.init().getSuperInvoices(JSON.stringify(filters), r => {
                this.allInvoices = [];
                if(r && r.result === "OK" && r.invoices && r.invoices.selected) {
                    this.allInvoices = r.invoices.selected.map(t => ({
                        amount: Number(t.amount || 0),
                        date: getLocalDateFromServer(t.date),
                        state: t.state,
                        type: t.type
                    }));
                } else {
					console.error("Failed to fetch invoices", r);
				}
            });
        },
        onDateFilterChanged(dateRange) {
            this.dateFilter = dateRange;
            this.fetchInvoicesForDateRange(dateRange.start, dateRange.end);
        },
        filterFailed() {
            if(this.$refs.invoicesTable && this.$refs.invoicesTable.filterFailedInvoices) {
                this.$refs.invoicesTable.filterFailedInvoices();
            }
        },
        onFiltersChanged(filters) {
            if (filters.date) {
                this.dateFilter = filters.date;
            }
            this.typeFilter = filters.type;
            this.fetchInvoicesForDateRange(this.dateFilter.start, this.dateFilter.end);
        }
    },
    mounted() {
        // Redirect super users who don't have access
        if (!this.superStore.isUltra && !this.superStore.isMega) {
            this.$router.push('/super/business');
            return;
        }
        
        // Fetch invoices for initial date range
        this.fetchInvoicesForDateRange(this.dateFilter.start, this.dateFilter.end);
        
        if(!this.superStore?.businesses?.length) {
            this.superStore.fetchBusinesses()
        }
    }
};
</script>
<style lang="scss" scoped>
    .container-super-invoices {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 40px;
		max-width: 1400px;
		margin: 0 auto;
    }
</style>